import { mixinMethods } from '@/main'
import store from '@/store'
import { initializeSubscription, disconnectSubscription } from '../helper'
import { onCreateTaskByAssignee, onUpdateTaskByAssignee, onDeleteTaskByAssignee } from '@/store/subscriptions'
import { tasksByAssigneeQuery } from '@/store/queries'

"use strict";
let subscriptionTask = null

const loadUserTasks = async function(){
    if(!store.state.userInfo?.id) return
    const input = { 
        taskAssigneeId: store.state.userInfo.id
    }
    const userTasks = await mixinMethods.gLoadListAll(
        tasksByAssigneeQuery, 
        input, 
        "tasksByAssignee"
    );
    const pendingTasks = userTasks.filter(task => task?.status?.toLowerCase() === "pending")
    store.commit('setUserTasks', pendingTasks)
}

export const taskSubscribe = function(instance){
    const queries = {
        onCreateTaskByAssignee,
        onUpdateTaskByAssignee,
        onDeleteTaskByAssignee
    }
    if(!store.state.userInfo?.id) return
    const input = {
        taskAssigneeId: store.state.userInfo.id
    }
    initializeSubscription(subscriptionTask, queries, input, "subscriptionStore/handleTask", instance)
}

export const config = function(subscriptions){
    const subscription = {}
    subscriptionTask = subscriptions['task'] = {
        loadList: loadUserTasks,
        subscribe: taskSubscribe,
        unsubscribe: (instance) => disconnectSubscription(subscription, instance),
        callback: taskEventCallback,
        subscription
    }
}

export const taskEventCallback = async function(subscriptionState, { data: task, eventName }){
    const eventNames = {
        'onCreate': async () => {
            if(task.status?.toLowerCase() === "pending") {
                store.commit('addUserTask', task)
            }
        },
        'onUpdate': async () => {
            store.commit('updateUserTask', task)
        },
        'onDelete': async () => {
            store.commit('removeUserTask', task.id)
        }
    }
    await eventNames[eventName]()
}